import tippy from 'tippy.js'

export default {
  mounted(el, binding, vnode) {
    vnode.tippy = tippy(el, {
      theme: 'light',
      maxWidth: 400,
      content: binding.value,
      trigger: 'mouseenter',
      allowHTML: true,
      onShow(instance) {
        // Don't show tooltip if content is empty, null, or undefined
        if (!instance.props.content) return

        const content = instance.popper.querySelector('.tippy-content')
        if (content) {
          content.classList.add('wrap-anywhere')
        }
      }
    })
  },
  updated(_, binding, vnode, oldVnode) {
    vnode.tippy = oldVnode.tippy
    vnode.tippy.setContent(binding.value)
  },
  unmounted(_, __, vnode) {
    vnode.tippy.destroy()
  }
}
